<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="categoryName" >
                        <span slot="label" ><a-tooltip>类别信息<template slot="title">类别信息</template></a-tooltip> </span>
                        <a-input v-model="categoryDisplay" :maxLength="100" :placeholder="$t('通用.输入.请输入')+'类别信息'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskType" >
                        <span slot="label" ><a-tooltip>任务类型<template slot="title">任务类型</template></a-tooltip> </span>
                        <a-input v-model="form.taskType" :maxLength="20" :placeholder="$t('通用.输入.请输入')+'任务类型'" />
                  </a-form-model-item>
                  <a-form-model-item prop="identityTagOptions" >
                        <span slot="label" ><a-tooltip>身份标签<template slot="title">身份标签配置，逗号分隔，如:男,女,本科,舞蹈老师,KTV,驾龄3年</template></a-tooltip> </span>
                        <div>
                          <a-tag v-for="(item, index) in identityTagsList" :key="index" closable @close="removeIdentityTag(index)">
                            {{ item }}
                          </a-tag>
                        </div>
                        <div style="margin-top: 8px;">
                          <a-input
                            v-model="identityTagInput"
                            :placeholder="$t('通用.输入.请输入')+$t('身份标签')"
                            @pressEnter="addIdentityTag"
                            style="width: 300px;"
                          />
                          <a-button type="primary" @click="addIdentityTag" style="margin-left: 8px;">{{ $t('添加标签') }}</a-button>
                        </div>
                  </a-form-model-item>
                  <a-form-model-item prop="unitOptions" >
                        <span slot="label" ><a-tooltip>单位配置<template slot="title">单位配置，逗号分隔，如:次,小时,天,单</template></a-tooltip> </span>
                        <div>
                          <a-tag v-for="(item, index) in unitOptionsList" :key="index" closable @close="removeUnitOption(index)">
                            {{ item }}
                          </a-tag>
                        </div>
                        <div style="margin-top: 8px;">
                          <a-input
                            v-model="unitOptionInput"
                            :placeholder="$t('通用.输入.请输入')+$t('单位')"
                            @pressEnter="addUnitOption"
                            style="width: 300px;"
                          />
                          <a-button type="primary" @click="addUnitOption" style="margin-left: 8px;">{{ $t('添加单位') }}</a-button>
                        </div>
                  </a-form-model-item>
                  <a-form-model-item prop="supportAppointment" >
                        <span slot="label" ><a-tooltip>支持预约<template slot="title">是否支持预约单 0否 1是</template></a-tooltip> </span>
                        <a-radio-group v-model="form.supportAppointment">
                          <a-radio :value="1">是</a-radio>
                          <a-radio :value="0">否</a-radio>
                        </a-radio-group>
                  </a-form-model-item>
                  <a-form-model-item prop="sortNo" >
                        <span slot="label" ><a-tooltip>排序值<template slot="title">排序值</template></a-tooltip> </span>
                        <a-input v-model="form.sortNo"  :placeholder="$t('通用.输入.请输入')+'排序值'" />
                  </a-form-model-item>
                  <a-form-model-item prop="status" >
                        <span slot="label" ><a-tooltip>状态<template slot="title">状态 1启用 0禁用</template></a-tooltip> </span>
                        <a-radio-group v-model="form.status">
                          <a-radio :value="1">启用</a-radio>
                          <a-radio :value="0">禁用</a-radio>
                        </a-radio-group>
                  </a-form-model-item>
                  <a-form-model-item prop="commissionRate" >
                        <span slot="label" ><a-tooltip>平台分成比例<template slot="title">平台分成比例（整数）</template></a-tooltip> </span>
                        <a-input-number v-model="form.commissionRate" :min="0" :max="100" :placeholder="$t('通用.输入.请输入')+'平台分成比例'" style="width: 100%" />
                  </a-form-model-item>
                  <a-form-model-item prop="remark" >
                        <span slot="label" ><a-tooltip>备注<template slot="title">备注</template></a-tooltip> </span>
                        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getTaskCategoryConfig, addTaskCategoryConfig, updateTaskCategoryConfig } from '@/api/task/taskCategoryConfig'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          id: null,
                          categoryCode: null,
                          categoryName: null,
                          taskType: null,
                          identityTagOptions: null,
                          unitOptions: null,
                          supportAppointment: null,
                          sortNo: null,
                      status: 0,
                          commissionRate: null,
                          remark: null,
                          createdAt: null,
                          updatedAt: null,
      },
      identityTagsList: [],
      identityTagInput: '',
      unitOptionsList: [],
      unitOptionInput: '',
      // 1增加,2修改
      formType: 1,
      open: false,
      categoryDisplay: '', // 用于显示的合并字段
      rules: {
          categoryName: [{ 
            validator: (rule, value, callback) => {
              if (!this.categoryDisplay || this.categoryDisplay.trim() === '') {
                callback(new Error('类别信息'+this.$t('通用.文本.不能为空')))
              } else {
                callback()
              }
            }, 
            trigger: 'blur' 
          }],
          taskType: [{ required: true, message: '任务类型'+this.$t('通用.文本.不能为空'), trigger: 'change' }],
          commissionRate: [
            { required: true, message: '平台分成比例' + this.$t('通用.文本.不能为空'), trigger: 'change' },
            { type: 'integer', message: '平台分成比例必须是整数', trigger: 'change' },
            { min: 0, max: 100, type: 'integer', message: '平台分成比例必须在0-100之间', trigger: 'change' }
          ] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    addIdentityTag() {
      if (this.identityTagInput && !this.identityTagsList.includes(this.identityTagInput)) {
        this.identityTagsList.push(this.identityTagInput.trim());
        this.identityTagInput = '';
      }
    },
    removeIdentityTag(index) {
      this.identityTagsList.splice(index, 1);
    },
    addUnitOption() {
      if (this.unitOptionInput && !this.unitOptionsList.includes(this.unitOptionInput)) {
        this.unitOptionsList.push(this.unitOptionInput.trim());
        this.unitOptionInput = '';
      }
    },
    removeUnitOption(index) {
      this.unitOptionsList.splice(index, 1);
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        categoryCode: null,
        categoryName: null,
        taskType: null,
        identityTagOptions: null,
        unitOptions: null,
        supportAppointment: null,
        sortNo: null,
        status: 0,
        commissionRate: null,
        remark: null,
        createdAt: null,
        updatedAt: null,
      }
      this.categoryDisplay = '',
      this.identityTagsList = []
      this.identityTagInput = ''
      this.unitOptionsList = []
      this.unitOptionInput = ''

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskCategoryConfig({"id":id}).then(response => {
        this.form = response.data
        // 展示时直接取类别名称
        this.categoryDisplay = this.form.categoryName || ''
        // 解析身份标签字符串到数组
        this.identityTagsList = this.form.identityTagOptions ? this.form.identityTagOptions.split(',') : []
        // 解析单位配置字符串到数组
        this.unitOptionsList = this.form.unitOptions ? this.form.unitOptions.split(',') : []
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      // 先赋值，再验证
      const value = this.categoryDisplay ? this.categoryDisplay.trim() : ''
      // 将类别名称的值赋给类别编码
      this.form.categoryName = value
      this.form.categoryCode = value
      // 将身份标签数组转换为逗号分隔字符串
      this.form.identityTagOptions = this.identityTagsList.join(',');
      // 将单位配置数组转换为逗号分隔字符串
      this.form.unitOptions = this.unitOptionsList.join(',');
      
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateTaskCategoryConfig(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.添加成功')
            addTaskCategoryConfig(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
